import { render, staticRenderFns } from "./ApplicantProjectSurveyFeedback.vue?vue&type=template&id=385ec5d8&"
import script from "./ApplicantProjectSurveyFeedback.vue?vue&type=script&lang=js&"
export * from "./ApplicantProjectSurveyFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports